import Modal from 'bootstrap/js/src/modal'
import { component, observable } from 'knockout-decorators'
import type { Observable } from 'knockout'

import source from './template.html?raw'

export type ModalOptions = {
  title?: string
  titleKey?: string

  body?: { name: string; params?: unknown }
  footer?: { name: string; params?: unknown }

  size?: 'sm' | 'lg' | 'xl'

  bsModalSettings: {
    backdrop: string
    show: boolean
    focus: boolean
    keyboard: boolean
  }

  show?: Observable<boolean>
  hidden: () => void
}

@component('bs-modal', source)
export class BootstrapModal {
  private el: HTMLElement | undefined = undefined
  private modal: Modal

  @observable isVisible = false

  constructor(private options: ModalOptions) {
    if (options.show) {
      options.show.subscribe((isVisible) => {
        isVisible ? this.modal.show() : this.modal.hide()
      })
    }
  }

  private loaded = (element: HTMLElement) => {
    this.el = element
    this.el.addEventListener('show.bs.modal', this.opening)
    this.el.addEventListener('shown.bs.modal', this.visible)
    this.el.addEventListener('hidden.bs.modal', this.hidden)
    this.modal = new Modal(element, this.options.bsModalSettings)
    if (this.options.show && this.options.show()) {
      this.isVisible = true
      this.modal.show()
    }
  }

  private opening = () => {
    this.isVisible = true
  }

  private visible = () => {
    const firstInput = this.el?.querySelector(
      '.modal-body input:not([disabled]), .modal-body button:not([disabled])'
    )
    if (firstInput) {
      ;(firstInput as HTMLElement).focus()
    }
  }

  private hidden = () => {
    this.isVisible = false
    this.options.hidden()
  }

  public dispose() {
    if (this.el) {
      this.el.removeEventListener('show.bs.modal', this.opening)
      this.el.removeEventListener('shown.bs.modal', this.visible)
      this.el.removeEventListener('hidden.bs.modal', this.hidden)
    }
    if (this.modal) {
      this.modal.dispose()
    }
  }
}
